export const environment = {
  production: false,
};

export const configProperties = {
  configPath: 'assets/config/app.config.json',
};

export const BG = {
  setAdm: 'grp_admin_negos@latam.com',
  setClient: 'grp_solicitante_negos@latam.com',
};
